import React, { cloneElement, useCallback, useEffect, useState } from 'react';
import { isEqual } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { RESET, SAVE_STATE } from '@store/trends/types';
import { sharingSelector } from '@store/trends/sharing/selectors';
import { Retry } from '@components/common';

let savedTrendsState: any = null;
const WithReset: React.FC<any> = ({
  children,
  ...props
}) => {
  const dispatch = useDispatch();
  const trendsState = useSelector(sharingSelector).state;

  const [initializing, setInitializing] = useState(true);

  const doneCallback = useCallback(() => {
    setInitializing(false);
  }, []);

  useEffect(() => {
    dispatch({ type: RESET, doneCallback });
  }, [dispatch]);

  useEffect(() => {
    if (!isEqual(trendsState, savedTrendsState)) {
      savedTrendsState = trendsState;
      dispatch({ type: SAVE_STATE, state: trendsState });
    }
  }, [trendsState, dispatch]);

  if(initializing) {
    return (
      <Retry
        isLoading
        showError={false}
      />
    );
  }

  const cloned = cloneElement(children, {...props});
  return <>{cloned}</>;
};

export default WithReset;
